import * as Dialog from "@radix-ui/react-dialog";
import { useState } from "react";
import { useQuizStore } from "../state/store";

type Props = {
  trigger: React.ReactNode;
};

export function ResetDialog({ trigger }: Props) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const resetAll = useQuizStore((s) => s.resetAll);

  async function handleConfirm() {
    setBusy(true);
    try {
      await resetAll();
      setOpen(false);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/70 backdrop-blur-sm z-40 animate-fade-in" />
        <Dialog.Content
          className="
            fixed z-50 bg-elevated shadow-modal p-5 space-y-4
            left-0 right-0 bottom-0 rounded-t-sheet border-t border-outline-strong animate-sheet-up
            sm:left-1/2 sm:top-1/2 sm:bottom-auto sm:right-auto sm:w-[420px]
            sm:-translate-x-1/2 sm:-translate-y-1/2
            sm:rounded-sheet sm:border sm:animate-slide-up
            safe-bottom sm:pb-5
          "
          data-testid="reset-dialog"
        >
          {/* Pull-handle indicator (mobile only) */}
          <div className="sm:hidden mx-auto -mt-1 mb-2 h-1.5 w-10 rounded-full bg-outline" aria-hidden />

          <Dialog.Title className="text-lg font-bold text-fg">
            Wirklich allen Fortschritt löschen?
          </Dialog.Title>
          <Dialog.Description className="text-sm text-fg-muted leading-relaxed">
            Diese Aktion kann nicht rückgängig gemacht werden. Alle gemeisterten Vokabeln und die
            Historie der falschen Antworten werden zurückgesetzt.
          </Dialog.Description>

          <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 pt-2">
            <Dialog.Close asChild>
              <button
                type="button"
                disabled={busy}
                className="min-h-[48px] px-4 py-2 rounded-lg bg-surface border border-outline text-fg text-sm font-semibold hover:bg-card focus:outline-none focus-visible:ring-2 focus-visible:ring-outline-strong disabled:opacity-50"
                data-testid="reset-cancel"
              >
                Abbrechen
              </button>
            </Dialog.Close>
            <button
              type="button"
              onClick={() => void handleConfirm()}
              disabled={busy}
              className="min-h-[48px] px-4 py-2 rounded-lg bg-danger text-white text-sm font-semibold hover:brightness-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-danger disabled:opacity-50"
              data-testid="reset-confirm"
            >
              {busy ? "Lösche …" : "Ja, löschen"}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
